// Sign-in screen, including the choose-a-new-password step invited users hit on
// first login (Cognito NEW_PASSWORD_REQUIRED challenge).

import { useEffect, useState, type FormEvent } from "react";
import { applyBrandToDocument, getAppBrand } from "../branding/appBrands";
import { brandVars } from "../branding/brandVars";
import { useAuth } from "./AuthContext";

export function LoginPage() {
  const { status, error, signIn, completeNewPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const isChallenge = status === "newPasswordRequired";
  const appBrand = getAppBrand();
  useEffect(() => applyBrandToDocument(appBrand), [appBrand]);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      if (isChallenge) {
        await completeNewPassword(newPassword);
      } else {
        await signIn(email.trim(), password);
      }
    } catch {
      // error state is set by the provider
    } finally {
      setBusy(false);
    }
  }

  return (
    // brandVars on the WRAPPER so the background gradient tints re-derive too
    <div className="sn-login-wrap" style={brandVars(appBrand)}>
      <form className="sn-login" onSubmit={onSubmit}>
        {appBrand.logoUrl && (
          <img className="sn-login-logo" src={appBrand.logoUrl} alt={appBrand.appName ?? ""} />
        )}
        <h1 className="sn-title">{appBrand.appName ?? "Side Nerd"}</h1>
        {appBrand.tagline && <p className="sn-login-hint">{appBrand.tagline}</p>}
        {isChallenge ? (
          <>
            <p className="sn-login-hint">
              Welcome! Choose a password to finish setting up your account
              (12+ characters with upper/lower case and a number).
            </p>
            <label>
              New password
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                autoComplete="new-password"
                minLength={12}
                required
              />
            </label>
          </>
        ) : (
          <>
            <label>
              Email
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="username"
                required
              />
            </label>
            <label>
              Password
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
            </label>
          </>
        )}
        {error && <div className="sn-error">{error}</div>}
        <button type="submit" disabled={busy}>
          {busy ? "Signing in…" : isChallenge ? "Set password" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
